export function buildCoachSystemPrompt() {
  return [
    'You are GreenPlan Coach, a practical and encouraging climate action advisor.',
    'Keep answers concise, useful, and actionable.',
    'Prefer recommendations from the provided action list when possible.',
    'Do not invent precise numeric claims unless they are in context.',
  ].join(' ');
}

export function buildCoachUserPrompt(context, question) {
  const {
    userName,
    region,
    footprint,
    doneActions,
    remainingActions,
    calculatorAnswers,
  } = context;

  const doneTitles = doneActions.map((a) => a.title).join(', ') || 'none';
  const remainingTitles = remainingActions.map((a) => a.title).join(', ') || 'none';

  return `
User profile:
- Name: ${userName || 'not provided'}
- Region: ${region}
- Estimated footprint: ${footprint.toFixed(1)} tCO2/year
- Completed actions: ${doneTitles}
- Remaining actions: ${remainingTitles}
- Calculator answers: ${JSON.stringify(calculatorAnswers)}

User question:
${question}

Return:
1) Short answer (2-4 sentences)
2) Up to 3 next actions, prioritized
3) One motivational sentence
`.trim();
}

export function buildRecommendationPrompt(context) {
  const { region, footprint, calculatorAnswers, remainingActions } = context;

  return `
You are generating a personalized recommendation list for GreenPlan.
Region: ${region}
Footprint: ${footprint.toFixed(1)} tCO2/year
Calculator answers: ${JSON.stringify(calculatorAnswers)}
Remaining actions: ${JSON.stringify(
    remainingActions.map((a) => ({ id: a.id, title: a.title, tier: a.tier, co2Saved: a.co2Saved }))
  )}

Return valid JSON only in this shape:
{
  "recommendations": [
    {"actionId": 1, "reason": "...", "priority": 1}
  ]
}

Recommend exactly 3 actions, sorted by priority ascending.
`.trim();
}
